/**
 * League Detail Constants
 * Centralized literals for the leagueDetail helper layer (status mapping,
 * fallback labels, route prefixes) to avoid duplicated magic strings.
 */

/**
 * Raw match status strings as they arrive from the server `/leagues/:id/schedule`
 * payload (compared case-insensitively after trim/uppercase). These mirror the
 * Prisma `MatchStatus` enum and map to client `GAME_STATUSES` values.
 */
export const RAW_MATCH_STATUSES = {
  FINISHED: 'FINISHED',
  LIVE: 'LIVE',
  IN_PLAY: 'IN_PLAY',
  PAUSED: 'PAUSED',
} as const;

export type RawMatchStatus = (typeof RAW_MATCH_STATUSES)[keyof typeof RAW_MATCH_STATUSES];

/** Fallback team label when neither name nor short name is available. */
export const UNKNOWN_TEAM_LABEL = 'Unknown';

/** Placeholder label for a knockout slot whose team is not yet decided. */
export const TBD_TEAM_LABEL = 'To be decided';

/**
 * Normalized (lowercase) name of the API-Football "Group Stage" aggregate
 * table, used for case-insensitive comparison in isAggregateGroupName.
 */
export const AGGREGATE_GROUP_NAME = 'group stage';

/** Route prefix for an individual match page (href = prefix + match id). */
export const MATCH_ROUTE_PREFIX = '/app/match/';
